import { useContext, useMemo } from 'react';

import { useInspectionHideTemplateEnabled } from 'react-hooks';
import { hasPermissionOrSuperUser } from 'lane-shared/helpers/hasPermission';
import { PERMISSION_KEYS } from 'constants-permissions';

import UserDataContext from 'lane-shared/contexts/UserDataContext';

/**
 * Whether the hide/unhide visibility control should be shown for a given
 * channel: the `inspection-hide-template` feature flag is on AND the current
 * user has `inspections.templates.manage` (or is a superuser) on that channel.
 *
 * Shared by the Template Library's row actions, Visibility column, and
 * `includeHidden` fetch argument, so they stay consistent with each other.
 */
export function useInspectionTemplateHideEnabled(
  channelId: string | undefined
): boolean {
  const { user } = useContext(UserDataContext);
  const flagEnabled = useInspectionHideTemplateEnabled();

  const hasHidePermission = useMemo(() => {
    if (!user || !channelId) {
      return false;
    }

    return hasPermissionOrSuperUser(
      user,
      [PERMISSION_KEYS.PERMISSION_INSPECTIONS_TEMPLATES_MANAGE],
      channelId
    );
  }, [user, channelId]);

  return flagEnabled && hasHidePermission;
}
